import angular from 'angular';
import angularMaterial from 'angular-material';
import phoneValidationFactory from './phoneValidation.factory';

const phoneValidationModule = angular
  .module('phoneValidation', [angularMaterial])
  .factory('PhoneValidation', phoneValidationFactory).name;

export default phoneValidationModule;



// WEBPACK FOOTER //
// ./client/app/components/user/userDetails/phoneValidation/phoneValidation.js